module.exports = __webpack_public_path__ + "img/logo_minedu.daf2b9e2.png";